<template>
  <v-select
    :items="entries"
    :label="label"
    :item-text="item_text"
    :item-value="item_pk"
    v-model="vmodel"
    outlined
    hide-no-data
    hide-details
    :disabled="disable"
    :dark="rdark"
  ></v-select>
</template>

<script>
//import Vue from "vue";
import ExecutaSQL from "../domain/ExecutaSQL";
export default {
  props: [
    "id",
    "item_text",
    "item_campos",
    "item_id",
    "item_pk",
    "item_left",
    "item_condicao",
    "item_ordem",
    "tabela",
    "label",
    "rdark",
    "disable",
    "value",
  ],
  data: () => ({
    vmodel: null,
    isLoading: false,
    search: null,
    descriptionLimit: 60,
    entries: [],
    campo_pk: "",
  }),
  computed: {},
  watch: {
    vmodel(val) {
      var wre = this.entries.filter((e) => {
        return e[this.item_id] == val;
      });

      var wnome = "";
      if (wre.length > 0) wnome = wre[0].nome;
      this.$emit("getID", {
        id: this.id,
        value: val,
        nome: wnome,
        dados: wre[0],
      });
    },
    value(val) {
      this.vmodel = val;
    },
  },
  created() {
    if (
      this.value != null &&
      this.value != "" &&
      typeof this.value != "undefined"
    )
      this.vmodel = this.value;
  },
  mounted() {
    this.buscaDadosValue(this.vmodel);
  },
  methods: {
    buscaDadosValue(val) {
      this.isLoading = true;

      var wcondicao = "";
      if (
        this.item_condicao != null &&
        this.item_condicao != "" &&
        typeof this.item_condicao != "undefined"
      )
        wcondicao = " WHERE " + this.item_condicao;

      var wsql =
        "SELECT " +
        this.item_campos +
        " FROM " +
        this.tabela +
        " " +
        this.item_left +
        " " +
        wcondicao +
        " ORDER BY " +
        this.item_ordem;

      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function (tmp) {
          this.entries = tmp;
          this.vmodel = val;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
  },
};
</script>